import axiosBase from "axios";

import { HTTP_REQUEST_STATUS_CODES } from "constants/constants";
import {
  URL_AUTHENTICATION_VALIDATE,
  URL_DOWNTIME_DETAILS,
  URL_SWAGGER,
} from "constants/Urls";
import { store } from "MainApp";
import { enableMaintenanceBanner } from "actions/adminSettings/maintenanceBanner/ActionsMaintenanceBanner";
import { initiateLogout } from "util/auth-utils";

const axiosInstance = axiosBase.create();

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === HTTP_REQUEST_STATUS_CODES.UNAUTHORIZED) {
      // do not signout when the request is to user validate api
      if (!String(error.config.url).endsWith(URL_AUTHENTICATION_VALIDATE)) {
        initiateLogout();
      }
    }

    /**
     * If the error is 418 then hide the banner if enabled and redirect to
     * application landing page and show the maintenance page
     */
    if (error.response?.status === HTTP_REQUEST_STATUS_CODES.SERVER_STOPPED) {
      /**disable if banner is displayed */
      store.dispatch(enableMaintenanceBanner(false));

      if (
        !String(error.config.url).endsWith(URL_SWAGGER) &&
        !String(error.config.url).endsWith(URL_DOWNTIME_DETAILS)
      ) {
        window.location.href = `${process.env.REACT_APP_NEXT_APP_URL}/next/maintenance`;
      }
    }

    /**return error in case of any other error code */
    return error;
  }
);

export const axios = axiosInstance;
